import React, { Component } from 'react';
import Menu from './components/menu';
import Header from './components/header';
import Biografi from './components/biografi';
import './App.css';
import Splintermind from './components/splintermind';
import Footer from './components/footer';
import $ from 'jquery';


function App() {
  return (
    <div className="App">
      <Menu />
      <Header />
      <Biografi />
      <Splintermind />
      <Footer />
    </div>
  );
}

export default App;
